import { FiX } from 'react-icons/fi'
import {
  LibraryOverlay,
  OptionsModal,
  LibraryHeader,
  LibraryBody,
  OptionsSectionTitle,
  PropertyRow,
  PropertyCheckboxRow,
} from './canvasStyles'

// Small settings dialog grouping the canvas "view options": the snap step used when placing/
// dragging nodes, the visual grid spacing (independent per direction), plus the label/load
// visibility toggles that used to live on the toolbar.
const SCALE_FIELDS = [
  { key: 'deformed', label: 'Deformada' },
  { key: 'diagram', label: 'Diagramas' },
  { key: 'node', label: 'Nós' },
  { key: 'support', label: 'Apoios' },
  { key: 'text', label: 'Textos (rótulos e valores)' },
]

export function ViewOptionsPanel({
  snapSize,
  setSnapSize,
  gridSpacingX,
  setGridSpacingX,
  gridSpacingY,
  setGridSpacingY,
  viewScales,
  setViewScales,
  showLoads,
  setShowLoads,
  showNodeLabels,
  setShowNodeLabels,
  showElementLabels,
  setShowElementLabels,
  onClose,
}) {
  return (
    <LibraryOverlay onClick={onClose}>
      <OptionsModal onClick={(e) => e.stopPropagation()}>
        <LibraryHeader>
          <h4 style={{ margin: 0 }}>Opções de visualização</h4>
          <button type="button" onClick={onClose} title="Fechar">
            <FiX />
          </button>
        </LibraryHeader>

        <LibraryBody>
          <OptionsSectionTitle>Grade</OptionsSectionTitle>
          <PropertyRow>
            Snap (m)
            <input type="number" min={0} step={0.01} value={snapSize} onChange={(e) => setSnapSize(e.target.value)} />
          </PropertyRow>
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Passo de encaixe ao criar ou arrastar nós. Reduza para posicionar elementos pequenos (ex.: espelho de 0,17 m
            e piso de 0,30 m de uma escada).
          </p>

          <PropertyRow style={{ marginTop: '12px' }}>
            Espaçamento das linhas verticais (m)
            <input
              type="number"
              min={0}
              step={0.1}
              value={gridSpacingX}
              onChange={(e) => setGridSpacingX(e.target.value)}
            />
          </PropertyRow>
          <PropertyRow>
            Espaçamento das linhas horizontais (m)
            <input
              type="number"
              min={0}
              step={0.1}
              value={gridSpacingY}
              onChange={(e) => setGridSpacingY(e.target.value)}
            />
          </PropertyRow>
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Distância entre as linhas da grade em cada direção (independente do Snap).
          </p>

          <OptionsSectionTitle>Escalas de exibição</OptionsSectionTitle>
          {SCALE_FIELDS.map((field) => (
            <PropertyRow key={field.key}>
              {field.label} (×)
              <input
                type="number"
                min={0}
                step={0.1}
                value={viewScales[field.key]}
                onChange={(e) => setViewScales((prev) => ({ ...prev, [field.key]: e.target.value }))}
              />
            </PropertyRow>
          ))}
          <p style={{ fontSize: '12px', opacity: 0.7, margin: '-4px 0 0' }}>
            Multiplicador de tamanho na tela (1 = padrão). Não altera os valores calculados, apenas a representação.
          </p>

          <OptionsSectionTitle>Exibição</OptionsSectionTitle>
          <PropertyCheckboxRow>
            <input type="checkbox" checked={showLoads} onChange={(e) => setShowLoads(e.target.checked)} />
            Mostrar cargas
          </PropertyCheckboxRow>
          <PropertyCheckboxRow>
            <input type="checkbox" checked={showNodeLabels} onChange={(e) => setShowNodeLabels(e.target.checked)} />
            Mostrar rótulos dos nós
          </PropertyCheckboxRow>
          <PropertyCheckboxRow>
            <input
              type="checkbox"
              checked={showElementLabels}
              onChange={(e) => setShowElementLabels(e.target.checked)}
            />
            Mostrar rótulos dos elementos
          </PropertyCheckboxRow>
        </LibraryBody>
      </OptionsModal>
    </LibraryOverlay>
  )
}
